// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".game-list[data-v-5679ab00] {\n  --game-list-title-color: var(--magic-tertiary, #311261);\n}\n@media (min-width: 1024px) {\n  .game-list[data-v-5679ab00] {\n    --game-list-title-color: var(--magic-light, #fff);\n  }\n}", ""]);
// Exports
module.exports = exports;
